import { ark } from '@ark-ui/react';
import { styled } from '@terra/ui-styled-system';
import { link } from '@terra/ui-styled-system';
import type { ComponentProps } from '@terra/ui-styled-system';

export type LinkProps = ComponentProps<typeof Link>;
export const Link = styled(ark.a, link);
